<template>
    <div class="contract-data" v-on:click="toContracts">
        <CRow>
            <CCol>
                <CWidgetBrand color="primary"
                              :right-header="powerContractCounts"
                              right-footer="contracts"
                              :left-header="volumeInGigs"
                              left-footer="Volume GWh"
                              class="w-100">
                    <CIcon name="cil-bolt"
                           height="48"
                           class="my-4" />
                </CWidgetBrand>
            </CCol>
        </CRow>
    </div>

</template>

<script>
    import Vue from 'vue';
    import apis from '@/common/network';

    export default Vue.extend({
        created() {
            this.fetchContractData()
        },
        data() {
            return {
                powerContractCounts: "-"
            }
        },
        methods: {         
            fetchContractData: function () {
                apis.protectedApi(`contract/contractEletrictyCount/${this.$store.state.loggedInUserId}`)
                    .then(response => {
                        this.powerContractCounts = response.data.count;
                    }).catch(e => {

                    }); 
            },
            toContracts(args) {
                this.$router.push({ name: "Contracts", params: { utilityType: "power" } });
            },
        },
        computed: {
            //powerContractCounts() {           
            //    return this.$store.state.homeVolumeData.powerContractIds ?
            //        this.$store.state.homeVolumeData.powerContractIds.length.toLocaleString() : "-";
         
    
            //},
            volumeInGigs() {
                return this.$store.state.homeVolumeData.powerVolumeGigs ?
                    Math.round(this.$store.state.homeVolumeData.powerVolumeGigs).toLocaleString() : "-"; 

            }
        }
    })
</script>

<style scoped>
    .dashboard-seo .dashboard-dynamic .contract-data {
        height: 100%;
        width: 100%;
    }

</style>